import React from 'react';
import { Button, Dialog, Input } from '@myosh/odin-components';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

interface QrCodeShareProps {
  isDialogVisible: boolean;
  onDialogClose: () => void;
}

export function QrCodeShare({ isDialogVisible, onDialogClose }: QrCodeShareProps) {
  const url = window.location.href;

  const { t } = useTranslation();

  const onCopy = () => {
    navigator.clipboard.writeText(url);
  };

  return (
    <Dialog header={t('qr-code')} visible={isDialogVisible} onClose={onDialogClose} containerClassName="sm:w-96">
      <>
        <QRCode size={200} value={url} level="M" />
        <div className="flex flex-col sm:flex-row align-bottom justify-center gap-4 mt-4">
          <Input label={t('record-link')} name="record-link" value={url} readOnly />
          <Button onClick={onCopy} classNames="mr-1">
            {t('copy')}
          </Button>
        </div>
      </>
    </Dialog>
  );
}
